<template>
  <!-- Content Row -->
  <div class="grid grid-cols-2 gap-4">
    <div class='col-span-2'>
      <label class="vs-input--label">{{ $t('UserRole') }}</label>
      <vs-select
        :disabled='Boolean(this.user_id)'
        name="user_role"
        v-validate="'required'"
        v-model="user.user_role"
        class="w-full select-large"
      >
        <vs-select-item
          :key="index"
          :value="item.value"
          :text="item.text"
          v-for="(item, index) in user_roles"
          :error-message="'sasdasdasd'"
        />
      </vs-select>
      <span class="text-danger text-sm" v-show="errors.has('user_role')">{{
        errors.first("user_role")
      }}</span>
    </div>

    <div v-show="user.user_role == 'user'">
      <vs-input
        class="w-full"
        :label="$t('IDNumber')"
        :placeholder="$t('Optional')"
        v-model="user.id_number"
        v-validate="'required'"
        name="id_number"
      />
      <span class="text-danger text-sm" v-show="errors.has('id_number')">{{
        errors.first("id_number")
      }}</span>
    </div>
    <div v-show="user.user_role == 'user'">
      <vs-input
        class="w-full"
        :label="$t('ExternalIDNumber')"
        :placeholder="$t('Optional')"
        v-model="user.external_id"
        v-validate="'required'"
        name="external_id"
      />
      <span class="text-danger text-sm" v-show="errors.has('external_id')">{{
        errors.first("external_id")
      }}</span>
    </div>

    <div>
      <vs-input
        class="w-full"
        :label="$t('FirstName')"
        v-model="user.first_name"
        v-validate="'required|alpha_spaces'"
        name="first_name"
      />
      <span class="text-danger text-sm" v-show="errors.has('first_name')">{{
        errors.first("first_name")
      }}</span>
    </div>
    <div>
      <vs-input
        class="w-full"
        :label="$t('LastName')"
        v-model="user.last_name"
        v-validate="'required|alpha_spaces'"
        name="name"
      />
      <span class="text-danger text-sm" v-show="errors.has('last_name')">{{
        errors.first("last_name")
      }}</span>
    </div>

    <div>
      <vs-input
        class="w-full"
        :label="$t('Email')"
        v-model="user.email"
        type="email"
        v-validate="'required|email'"
        name="email"
      />
      <span class="text-danger text-sm" v-show="errors.has('email')">{{
        errors.first("email")
      }}</span>
    </div>
    <div>
      <vs-input
        class="w-full"
        :label="$t('MobileNumber')"
        v-model="user.mobile_number"
        type="text"
        v-validate="'required|numeric'"
        name="mobile_number"
      />
      <span class="text-danger text-sm" v-show="errors.has('mobile_number')">{{
        errors.first("mobile_number")
      }}</span>
    </div>

    <div class='col-span-full'>
      <label for="" class='vs-input--label'>Tags</label>
      <input-tag
        :add-tag-on-blur='true'
        :before-adding='sanitizeTag'
        class="w-full"
        :label="$t('Tag')"
        v-model="user.tags"
        type="text"
        v-validate="'required'"
        name="tags"
      />
      <span class="text-danger text-sm" v-show="errors.has('tags')">{{
        errors.first("tags")
      }}</span>
    </div>
    <template v-if="user.user_role != 'user'">
      <div>
        <vs-input
          ref="password"
          class="w-full"
          label="Password"
          v-model="user.password"
          type="password"
          v-validate="'required'"
          name="password"
        />
        <span class="text-danger text-sm" v-show="errors.has('password')">{{
          errors.first("password")
        }}</span>
      </div>

      <div>
        <vs-input
          class="w-full"
          label="Confirm Password"
          v-model="user.password_confirmation"
          type="password"
          v-validate="'required|confirmed:password'"
          name="password_confirmation"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('password_confirmation')"
          >{{ errors.first("password_confirmation") }}</span
        >
      </div>
    </template>

		<div class='col-span-full'>
    	<vs-button class='float-left' :disabled='submitted' @click.prevent.stop="handleSubmit($event)">Save</vs-button>
		</div>

  </div>
</template>

<script>
import UserRoles from "@/utils/user-roles";
import { createUpdateUser } from "@/api/user";
import InputTag from 'vue-input-tag'

export default {
  components: { InputTag },
  data: () => ({
    submitted: false,
    user: {
      tags: [],
      id: null,
      first_name: null,
      last_name: null,
      user_role: "user",
      external_id: null,
      id_number: null,
      mobile_number: null,
      email: null,
      password: null,
      password_confirmation: null,
    },
  }),
  computed: {
    user_roles() {
      return UserRoles;
    },
    user_id() {
      return this.$route.params.id;
    },
  },
  mounted(){
    if(this.user_id)
      this.getSpecificUserData();
  },
	methods: {
    sanitizeTag: (tag) => tag.replaceAll(/\s\s+/gi, ' '),
		async handleSubmit(e) {
        this.submitted = true;
        const valid = await this.$validator.validate();
        
        if(!valid || (this.user.user_role!='user' && this.user.password != this.user.password_confirmation)) {
          this.$vs.notify({
            title: this.$t("create_admin.FailedToCreateAdmin"),
            text: this.$t("create_admin.ConfirmPasswordFailed"),
            color: "danger",
            position: "top-center"
          });
          this.submitted = false;
          return false;
        }

        this.$vs.loading();
        const data = {...this.user};
        try{ 
          const response = await createUpdateUser(data);
          
          this.$vs.notify({
            title: this.$t("Success"),
            text: this.user_id ? this.$t('UserUpdatedSuccessfull') : this.$t('UserCreatedSucessfull'),
            color: "success",
            position: "top-center"
          });

          if(response.status == 200 && response.data.id)
            this.$router.push({name:'ViewUser', params: {id:response.data.id}});
        }catch(error){
          this.$vs.notify({
              title: this.$t("create_admin.FailedToCreateAdmin"),
              text: error,
              color: "danger",
              position: "top-center"
          });
        }
        this.submitted = false;
        this.$vs.loading.close();
    },
    async getSpecificUserData() {
      this.$vs.loading();

      try{
        const response  = await this.$store.dispatch("GetUserDataById", this.user_id);
        const user = response.data.data;
        this.user = {
          ...this.user,
          id: user.id,
          first_name: user.first_name,
          last_name: user.last_name,
          user_role: user.user_role,
          external_id: user.external_id ? user.external_id : null,
          id_number: user.id_number,
          mobile_number: user.mobile_number,
          email: user.email,
          tags: user.tags.map(tag => tag.name)
        };
      }catch(error) {
        this.$log.error(
          "File : Settings.vue | Function : getConfigData() | Error :",
          error
        );
        this.$vs.loading.close();
        // Error response
        this.$vs.notify({
          title: $t("FailedToLoadData"),
          text: error,
          color: "danger",
          position: "top-center",
        });
      }
      
      this.$vs.loading.close();
    },
	}
};
</script>

<style>
</style>